(ns ycweb.components.common
  (:require
   [rum.core :as rum]
   [rum.cursor]
   [util.string :as str]
   [ycweb.util.core :as u]
   #?@(:cljs
       [[cljs-time.core :as dt]]
       :clj
       [[clj-time.core :as dt]]))
  #?(:cljs
     (:require-macros
      [ycweb.components.common]))
  #?(:clj
     (:import
      [clojure.lang IAtom]
      (java.util.concurrent Executors ScheduledExecutorService TimeUnit)
      (rum.cursor Cursor))))

#?(:clj
   (def scheduled-executors
     (Executors/newScheduledThreadPool 1)))

(defonce lifecycle-listeners (atom {}))

(defn lifecycle-listener [rk lifecycle-key f]
  (swap! lifecycle-listeners assoc-in [lifecycle-key rk] f)
  f)

(defn lifecycle-event [lifecycle-key app-atom]
  (doseq [[_ f] (get @lifecycle-listeners lifecycle-key)]
    (f app-atom)))

(defn timeout-fn-call [f delayms]
  #?(:clj
     ;; Untested, but should work.
     (.schedule ^ScheduledExecutorService
       scheduled-executors ^Runnable f delayms TimeUnit/MILLISECONDS)

     :cljs
     (.setTimeout js/window #(f) delayms)))

(def ^:private ^:dynamic *cursors*)

(defonce cursor-registry (atom {}))

(defn cursor-in [atm ks]
  #?(:cljs
     (assert *cursors*
       "You need to call cursor-in in conjunction with `cursors` mixin on a rum component."))

  #?(:cljs
     (let [registered
           (swap! cursor-registry update [atm ks]
             (fn [c]
               (or c {:cursor (rum/cursor-in atm ks)})))]
       (vswap! *cursors* conj [atm ks])
       #_(println
           "Cursor: " (pr-str ks)
           (get-in registered [[atom ks] :cursor]))
       (get-in registered [[atm ks] :cursor]))

     :clj
     (rum/cursor-in atm ks)))

(defn register-cursor-in [atm ks]
  (let [registered
        (swap! cursor-registry update [atm ks]
          (fn [c]
            (->
              (or c {:counter 0 :cursor (rum/cursor-in atm ks)})
              (update :counter (fnil inc 0)))))]
    (get-in registered [[atm ks] :cursor])))

(defn release-cursor-in [atm ks]
  (swap! cursor-registry
    (fn [r]
      (let [c (get r [atm ks])]
        (cond
          (nil? c)
          r

          (not (pos? (dec (:counter c))))
          (dissoc r [atm ks])

          :else
          (update-in r [[atm ks] :counter] dec)))))
  nil)

(def cursors
  "Mixin. Works in conjunction with [[cursor-in]].

   ```
   (rum/defc comp < cmn/with-cursors rum/reactive
     [app-atom]
     [:div (rum/react (cmn/cursor-in app-atom [:counter]))])

   (def app-atom (atom {:counter 0}))
   (rum/mount (comp app-atom) js/document.body)
   (swap! app-atom update :counter inc) ;; will force comp to re-render
   ```"
  {:wrap-render
   (fn [render-fn]
     (fn [state]
       ;; TODO: Don't bind if already bound
       (binding [*cursors* (volatile! #{})]
         (let [old-cursors (:rum.cursors/refs state #{})
               [dom next-state] (render-fn state)
               new-cursors @*cursors*]

           (doseq [[a ks] new-cursors]
             (register-cursor-in a ks))

           (doseq [[a ks] old-cursors]
             (release-cursor-in a ks))

           [dom (assoc next-state :rum.cursors/refs new-cursors)]))))

   :will-unmount
   (fn [state]
     (doseq [[a ks] (:rum.cursors/refs state)]
       (release-cursor-in a ks))
     (dissoc state :rum.cursors/refs))})

(defn curact [atm ks]
  (when atm
    (let [cursor
          (cond
            *cursors*
            (cursor-in atm (if (keyword? ks) [ks] ks))

            (keyword? ks)
            (rum/cursor atm ks)

            :else
            (rum/cursor-in atm ks))]
      (if #?(:cljs rum.core/*reactions* :clj false)
        (rum/react cursor)
        @cursor))))

(defn curval [v]
  (cond
    (nil? v) v
    (fn? v) (v)
    (or
      (instance? #?(:clj IAtom :cljs Atom) v)
      (instance? #?(:clj Cursor :cljs rum.cursor/Cursor) v))
    (if #?(:cljs rum.core/*reactions* :clj false)
      (rum/react v)
      @v)
    :else v))

(defn curact-keys
  "Given an atom that contains a map and watcher key (unique for your atom and use),
   provide a set of keys and react on a derived version of the atom that will only
   react on changes to that set of keys.

   Helpful for when you want to need to work with a subset of keys in a component,
   but not all of it."
  [atm watcher-key ks]
  (rum/react
    (rum/derived-atom [atm] watcher-key
      (fn [a]
        (select-keys a ks)))))

(defonce profile-atom (atom {}))

(defn profile
  "Profile a rum component - adds a small div wrapper with a local render count and total re-render profile time"
  [desc]
  {:wrap-render
   (fn wrap-render [render-fn]
     (fn [state]
       #?(:cljs
          (let [start (dt/now)
                res (render-fn state)
                length (dt/in-millis (dt/interval start (dt/now)))]
            (swap! profile-atom update-in [desc]
              (fn [p]
                (-> p
                  (update :total-time (fnil + 0 0) length)
                  (update :total-count (fnil inc 0))
                  (update :avg-time #(/ (+ length %) 2)))))

            res)

          :clj
          (render-fn state))))})

(rum/defc profile-view < rum/reactive []
  (let [profiles (rum/react profile-atom)]
    [:div
     {:style
      {:z-index 1000
       :position :fixed
       :top "0px"
       :left "0px"}}
     (when-not (empty? profiles)
       [:table
        {:style
         {:font-size "8px"
          :background-color "yellow"
          :border-size "1px"}}
        (into
          [:tbody]
          (map
            (fn [[desc {:keys [total-time total-count avg-time]}]]
              [:tr
               [:td desc]
               [:td total-count]
               [:td (u/number-format total-time) "ms"]
               [:td (u/number-format avg-time 2) "ms"]])
            profiles))])]))

;; Don't use this version with a cursor - you can't remove the bounce and it'll probably duplicate, bouncing multiple times
;; Use debounce-in instead, passing in the root atom.
(defn debounce-atom [local-atom debounce-ms & [change-fn start-fn]]
  (remove-watch local-atom :bounce-watch)
  (add-watch local-atom :bounce-watch
    (fn [_ _ o n]
      (when (not= o n)
        (when start-fn (start-fn n))
        (timeout-fn-call
          #(when (= n @local-atom)
             (when change-fn (change-fn n)))
          debounce-ms)))))

(defn debounce-in [local-atom path debounce-ms & [change-fn start-fn]]
  (remove-watch local-atom [:bounce-watch path])
  (add-watch local-atom [:bounce-watch path]
    (fn [_ _ old-value new-value]
      (let [o (get-in old-value path)
            n (get-in new-value path)]
        (when (not= o n)
          (when start-fn (start-fn n))

          (timeout-fn-call
            #(when (= n (get-in @local-atom path))
               (when change-fn (change-fn n)))
            debounce-ms))))))

(defn local
  ([initial] (local initial :rum/local))
  ([initial k]
   {:will-mount
    (fn [state]
      (assoc state k (atom initial)))}))

(rum/defc section [title & rows]
  (into
    [:div.section
     (when title
       [:h2 {:class (u/bem :heading [:large])} title])]
    rows))

(rum/defc row-full [title & content]
  [:div.flex-grid-group
   (into
     [:div
      {:class (u/bem :flex-grid-block [:full])}
      [:div.flex-grid-content
       [:small.u-block.u-margin-bottom-8
        title]
       content]])])

(rum/defc label < rum/reactive [text-or-atom & ks]
  [:span
   (if ks (curact text-or-atom ks)
     (curval text-or-atom))])

;; Helper function for auto-focus check... make sure to run this is a reactive component
(defn auto-focus? [app-atom]
  (not (curact app-atom :disable-auto-focus)))

(defn scroll-position []
  #?(:cljs
     {:x (.-scrollX js/window) :y (.-scrollY js/window)}
     :clj
     {:x 0 :y 0}))

(defn screen-size []
  #?(:cljs
     {:width (.-innerWidth js/window)
      :height (.-innerHeight js/window)}
     :clj
     {:width 0
      :height 0}))

(defonce overridden-global-keys (atom nil))

(defn override-global-keys? []
  @overridden-global-keys)

(defn override-global-keys
  "Disables all global modal key handling, remember to call restore-global-keys when you're done, keep the scope small
   so that you don't leak a state where you don't restore."
  []
  (reset! overridden-global-keys true))

(defn restore-global-keys
  "Re-enable global modal key handling"
  []
  (reset! overridden-global-keys false))

(defn default-warehouse
  "Pick a default warehouse, if we can't figure out which is default, user must decide"
  [warehouse-list]
  (let [default-warehouses
        (->>
          warehouse-list
          (filter :default))]

    (if (> (count default-warehouses) 1)
      nil
      (first default-warehouses))))

(defn has-permission? [app-atom permission]
  (contains?
    (get-in @app-atom [:user :permissions])
    permission))

(defn permission-lock [app-atom permission body]
  (if (has-permission? app-atom permission)
    body
    [:div
     [:h1 "Insufficient permissions"]
     [:span "Please check that you have permission to do this, try logout and log back in if your permission has been updated recently."]]))

(defn has-any-permission? [app-atom permissions]
  (->>
    permissions
    (filter
      #(has-permission? app-atom %))
    (not-empty)))

(defn multi-permission-lock [app-atom permissions body]
  (if (has-any-permission? app-atom permissions)
    body
    [:div
     [:h1 "Insufficient permissions"]
     [:span "Please check that you have permission to do this, try logout and log back in if your permission has been updated recently."]]))

(defn permission-hide [app-atom permission body]
  (when (has-permission? app-atom permission)
    body))

(defn process-name [app-atom]
  (let [page (curact app-atom [:page :screen])]
    (if (namespace page) (keyword (namespace page)) page)))

(defn process-action-name [app-atom]
  (curact app-atom [:page :screen]))

(defn action-name [app-atom]
  (let [page (process-action-name app-atom)]
    (keyword (name page))))

(defn page-base-url [app-atom]
  (let [page (get @app-atom :page)]
    (get-in page [(:screen page) :base])))

(defn process-cursor [app-atom]
  (let [page (curact app-atom [:page :screen])]
    (rum/cursor-in app-atom [(if (namespace page) (keyword (namespace page)) page)])))

(defn action-cursor-path [app-atom]
  (curact app-atom [:page :screen]))

(defn action-cursor [app-atom]
  (rum/cursor-in app-atom [(action-cursor-path app-atom)]))

(defn process-action-cursor [app-atom]
  (let [page (curact app-atom [:page :screen])
        path
        (if (namespace page)
          [(keyword (namespace page)) (keyword (str "action-" (name page)))]
          [page])]
    (rum/cursor-in app-atom path)))

(defn screen-params [app-atom]
  (let [screen (curact app-atom [:page :screen])]
    (curact app-atom [:page screen :params])))

(defn get-cookie-reactive [app-atom k]
  (curact app-atom [:page :cookies k]))
